import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import './Checkbox.css';

const Checkbox = ({
  className,
  id,
  name,
  onChange,
  onFocus,
  onBlur,
  checked = false,
  disabled = false,
  style,
  children,
  error,
}) => {
  const handleChange = (e) => {
    if (!disabled) {
      onChange({
        target: {
          name: e.target.name,
          checked: e.target.checked,
        },
      });
    }
  };
  return (
    <div
      className={clsx(
        'alf-checkbox',
        className,
        disabled && 'disabled',
        error && 'error',
      )}
      style={style}
    >
      <input
        id={id}
        data-testid={id}
        type="checkbox"
        name={name}
        onChange={handleChange}
        onKeyDown={(event) => {
          if ((event.key === 'Enter' || event.key === ' ') && handleChange) {
            handleChange(event);
          }
        }}
        checked={checked}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
      />
      {children}
    </div>
  );
};

Checkbox.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  style: PropTypes.object,
};

export default Checkbox;
